import React from "react";
import "./Header.css";
import { FaLightbulb } from "react-icons/fa";
import { configShop } from '../../states/configShop';
import { FaFacebook, FaInstagram, FaTwitter, FaTiktok, FaYoutube, FaTripadvisor } from "react-icons/fa";
import Rating from "../componente/Rating";
const Header = ({ properties }) => {
  const { dataConfig } = configShop();
  const abierto = dataConfig?.branch?.status ?? true;
  return (
    <header
      className="container py-3"
      style={{ color: dataConfig.color_background ?? "#000000" }}
    >
      <div className="row">

        {/* Columna izquierda (Logo + nombre + redes) */}
        <div className="col-6 d-flex flex-column align-items-start text-start mb-3 mb-lg-0">
          <img
            src={dataConfig?.page_home?.logo_image}
            alt={dataConfig?.page_home?.title}
            className="img-fluid header-logo-2 mb-2"
            style={{ maxHeight: "80px", width: "auto", display: "block" }}
          />
          <h1
            className="restaurant-name-v2 mb-1"
            style={{ "--btn-font-color": dataConfig?.page_home?.color_title }}
          >
            {dataConfig?.page_home?.title}
          </h1>
          <div className="social-icons my-2">

            {dataConfig?.social?.instragram && (

              <a
                href={`https://www.instagram.com/${dataConfig.social.instragram}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram color={dataConfig?.page_home?.color_description} size={30} className="mx-1" />
              </a>
            )}

            {dataConfig?.social?.facebook && (
              <a
                href={`https://www.facebook.com/${dataConfig.social.facebook}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook color={dataConfig?.page_home?.color_description} size={30} className="mx-1" />
              </a>
            )}

            {dataConfig?.social?.tiktok && (
              <a
                href={`https://www.tiktok.com/@${dataConfig.social.tiktok}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTiktok color={dataConfig?.page_home?.color_description} size={30} className="mx-1" />
              </a>
            )}

            {dataConfig?.social?.twiter && (
              <a
                href={`https://twitter.com/${dataConfig.social.twiter}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter color={dataConfig?.page_home?.color_description} size={30} className="mx-1" />
              </a>
            )}

            {dataConfig?.social?.youtube && (
              <a
                href={`https://www.youtube.com/${dataConfig.social.youtube}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube color={dataConfig?.page_home?.color_description} size={30} className="mx-1" />
              </a>
            )}
            {dataConfig?.social?.tripadvisor && (
              <a
                href={dataConfig.social.youtube}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTripadvisor color={dataConfig?.page_home?.color_description} size={30} className="mx-1" />
              </a>
            )}


          </div>
          <p className="option-sub-header" style={{ "--btn-font-color": dataConfig?.page_home?.color_description }}>Tiempo de entrega:<br /> {dataConfig?.time_delivery}</p>
         
          {dataConfig?.page_home?.description && (
            <h2
              className="restaurant-name-v2 mb-1"
              style={{ "--btn-font-color": dataConfig?.page_home?.color_description }}
            >
              {dataConfig?.page_home?.description}
            </h2>
          )}
        </div>


        {/* Columna derecha (Estado + calificación) */}
        <div className="col-6 d-flex flex-column align-items-end text-end mb-3 mb-lg-0">
          <div className={`estado ${abierto ? "abierto" : "cerrado"}`}>
            {abierto ? (
              <>
                <FaLightbulb className="text-warning bombillo-titilando me-1" />
                Abierto ahora
              </>
            ) : (
              "Cerrado por ahora"
            )}
          </div>
          <div className="calificacion-2 text-end">
            <Rating rating={dataConfig?.qualification} totalReviews={dataConfig?.reviews} />
          </div>

        </div>


      </div>
    </header>

  );
};

export default Header;
